import { c as _c } from "react/compiler-runtime";
import { LinkifiedText } from '@/components/common/LinkifiedText';
interface LinkifiedVaultDescriptionProps {
  description: string;
}
export const LinkifiedVaultDescription = t0 => {
  const $ = _c(2);
  const {
    description
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = <span className="text-secondary-foreground text-xs"><LinkifiedText text={description} /></span>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};